module.exports = __webpack_public_path__ + "static/l-slide02-daeca8535b1d6fb871fbccc16348b244.png";